import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { ShipmentsPage } from '#/modules/shipments/shipments-page'

export const Route = createFileRoute('/_shell/shipments/')({
  component: ShipmentsPage,
  validateSearch: validateListSearch,
})
